import React from 'react'; 
import * as moment from 'moment';
import 'moment/locale/ru';
import PropTypes from 'prop-types';

const PhotoVideoCard = props => (
    <div className={`card ${props.cardSize}`}>
        <div className="card__link">
            <div className="card__image" style={{ backgroundImage: `url( ${props.data.cover.article})` }}>
                {props.data.imageCount
                    ? <div className="card__count">
                        <span className="card__count_text">{props.data.imageCount}</span>
                    </div>
                    : <div className="card__button">
                        <span className=" card__button_play" />
                    </div>
                }
            </div>
            <div className="card__text">
                <a
                    href={props.data.href}
                    target="_blank"
                    className="card__text_title"
                    title={props.data.title}
                >
                    {props.cardSize === 'card_small' && props.data.title.length > 30 ? `${props.data.title.substr(0, 27)}...` : props.data.title}
                </a>
                <time className="card__text_date">{moment(props.data.publishTime.sec * 1000).format('LLL')}</time>
            </div>
        </div>
    </div>
);

PhotoVideoCard.propTypes = {
    data: PropTypes.objectOf(PropTypes.any),
    cardSize: PropTypes.string
};

PhotoVideoCard.defaultProps = { 
    data: null,
    cardSize: null
};

export default PhotoVideoCard;



// WEBPACK FOOTER //
// ./src/components/PhotoVideoCard.jsx